import { Progress } from 'antd'
import Numeral from 'numeral'
import { useMemo } from 'react'
import { Link } from 'react-router-dom'

import Arrow from '@/assets/Arrow.png'
import WAN from '@/assets/WAN.png'
import { useLocalStorage } from '@/context/localstorage-context'
import { cutString } from '@/utils'

import {
  ArrowStyle,
  BottomArea,
  Card,
  CardContentCon,
  CardHeader,
  CardPart1,
  CardPart2,
  Container,
  Data,
  FeeRate,
  HeartPercent,
  Icon,
  IconContainer,
  MyCard,
  Percent,
  PosName,
  StakeData1,
  StakeData2,
  TextIcon,
} from './PosCard.module'

export const CardContent = ({ staker }: { staker: any }) => {
  return (
    <CardContentCon>
      <CardPart1>
        <span style={{ fontSize: '12px', color: '#BFBFBF' }}>STAKE</span>
        <StakeData1 className="text-light-0 dark:text-white">
          {staker.totalAmountFmt || '--/--'}
        </StakeData1>
      </CardPart1>
      <CardPart2>
        <span
          className="text-light-111 dark:text-light-222"
          style={{ fontSize: '16px' }}
        >
          {staker.quotaLeft || '--/--'}
        </span>
        <StakeData2>QUOTA</StakeData2>
      </CardPart2>
    </CardContentCon>
  )
}

export default function CardPart({ staker }: { staker: any }) {
  const { theme } = useLocalStorage()

  const isdark = useMemo(() => theme === 'dark', [theme])

  return (
    <Container isdark={isdark}>
      <Link to={`/posdetail/${staker.address}`}>
        <Card className="card bg-white dark:bg-dark-222">
          <CardHeader>
            <div style={{ textAlign: 'left' }}>
              <IconContainer>
                <Icon
                  src={`data:image/${staker.iconType};base64,${staker.iconData}`}
                  alt={staker.name}
                />
              </IconContainer>
              <PosName className="text-light-0 dark:text-white">
                {staker.name.startsWith('0x')
                  ? cutString(staker.name, 8)
                  : staker.name}
              </PosName>
            </div>
            <ArrowStyle className="arrowStyle" src={Arrow} alt="arrow" />
          </CardHeader>
          <Progress
            width={160}
            type="circle"
            trailColor={isdark ? '#135C8F' : '#F2F2F2'}
            strokeWidth={5}
            strokeColor={isdark ? '#112A3B' : '#D7DEE3'}
            percent={100 - staker.capacityUsedPercentage}
            format={() => <CardContent staker={staker} />}
          />
          <div style={{ height: '40px' }}>
            <BottomArea>
              <HeartPercent>
                <Percent>{Numeral(staker.activity).format('0,0%')}</Percent>
                <TextIcon>Activity</TextIcon>
              </HeartPercent>
              <FeeRate>
                <Percent style={{ color: '#2FBDF4' }}>
                  {staker.feeRateFmt}
                </Percent>
                <TextIcon>Fee Rate</TextIcon>
              </FeeRate>
            </BottomArea>
          </div>
        </Card>
        <MyCard className="mycard bg-light-666 dark:bg-dark-555">
          <Data>
            <span>My Delegations</span>
            <span className="text-light-0 dark:text-white">
              {Numeral(staker.myDelegate)
                .format('0,0.00')
                .replace(/\.?0+$/, '')}
              &nbsp;
              <img
                style={{ position: 'relative', top: '-1px' }}
                src={WAN}
                alt="WAN"
              />
            </span>
          </Data>
          <Data>
            <span>My Rewards</span>
            <span className="text-dark-111">
              {Numeral(staker.myTotalIncentive)
                .format('0,0.0000')
                .replace(/\.?0+$/, '')}
              &nbsp;
              <img
                style={{ position: 'relative', top: '-1px' }}
                src={WAN}
                alt="WAN"
              />
            </span>
          </Data>
        </MyCard>
      </Link>
    </Container>
  )
}
